module.exports = __webpack_public_path__ + "static/media/art64.15915985.jpg";